export const ADMIN_ROUTE = '/admin'

export const ADMIN_ACCOUNT_ROUTE = `${ADMIN_ROUTE}/account`

export const ADMIN_BOOKING_ROUTE = `${ADMIN_ROUTE}/reservation-rapide`
export const ADMIN_CUSTOMER_FILES_ROUTE = `${ADMIN_ROUTE}/customer-files`

export const ADMIN_CMS_ROUTE = `${ADMIN_ROUTE}/cms`
export const ADMIN_CMS_CATALOG_ROUTE = `${ADMIN_CMS_ROUTE}/catalog`
export const ADMIN_CMS_CATALOG_EDITION_ROUTE = `${ADMIN_CMS_CATALOG_ROUTE}/catalog`
export const ADMIN_CMS_GENERAL_INFORMATION_ROUTE = `${ADMIN_CMS_ROUTE}/general-information`
export const ADMIN_CMS_IMAGES_MANAGEMENT = `${ADMIN_CMS_ROUTE}/images-management`
export const ADMIN_CMS_KNOWLEDGE_BASE_ROUTE = `${ADMIN_CMS_ROUTE}/knowledge-base`
export const ADMIN_CMS_KNOWLEDGE_BASE_ARTICLE_EDITION_ROUTE = `${ADMIN_CMS_KNOWLEDGE_BASE_ROUTE}/article`
export const ADMIN_CMS_KNOWLEDGE_BASE_FORM_EDITION_ROUTE = `${ADMIN_CMS_KNOWLEDGE_BASE_ROUTE}/form`
export const ADMIN_CMS_KNOWLEDGE_BASE_TUTORIAL_EDITION_ROUTE = `${ADMIN_CMS_KNOWLEDGE_BASE_ROUTE}/tutorial`
export const ADMIN_CMS_PRODUCT_ROUTE = `${ADMIN_CMS_ROUTE}/product`
export const ADMIN_CMS_SMART_DIAGNOSTIC_ROUTE = `${ADMIN_CMS_ROUTE}/smart-diagnostic`
export const ADMIN_CMS_STEP_ROUTE = `${ADMIN_CMS_ROUTE}/diagnostic`
export const ADMIN_CMS_STEP_EDITION_ROUTE = `${ADMIN_CMS_STEP_ROUTE}/step`

export const ADMIN_DASHBOARD_ROUTE = `${ADMIN_ROUTE}/dashboard`

export const ADMIN_LOGIN_ROUTE = `${ADMIN_ROUTE}/login`

export const ADMIN_TICKETS_ROUTE = `${ADMIN_ROUTE}/tickets`

export const ARTICLE_ROUTE = '/article'

export const SEARCH_RESULTS_ROUTE = '/search-results'
